<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
      <v-dialog
        title='客户名片'
        v-model="item.show"
        persistent
        max-width='700'
      >
      <v-card>
        <v-app-bar flat color="rgba(0, 0, 0, 0)">

          <v-toolbar-title class="size-26 pl-1">
            {{item.data.name}}
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <p class="white--text size-17 mr-n7 mt-3">
            <v-chip color="primary" label text-color="white">
              <v-icon left>mdi-star-outline</v-icon>
              {{item.data.degreeDic  === null || item.data.degreeDic  === undefined  ? '' : item.data.degreeDic.name}}客户
            </v-chip>
          </p>
        </v-app-bar>

        <v-card-title class="grey--text my-0 blue-grey lighten-5">
          <v-avatar size="70">
            <img alt="user" :src="require('@/assets/def-head.jpeg')">
          </v-avatar>
          <div class="ml-3 size-17">
            <v-icon color="grey" size="21" class="mr-2">mdi-account</v-icon>
            <span v-for="(itm, i) in item.data.allContactsPersons" :key="i" class="size-15">
              {{itm.name}}
              <span v-if="(i+1)< item.data.allContactsPersons.length">|</span>
            </span>
            <br>
            <v-icon color="grey" size="20" class="mr-2">mdi-phone</v-icon>
            <span v-for="(it, idx) in item.data.allContactsPersons" :key="`idx-${idx}`" class="size-15">
              {{it.phoneNumber}}
              <span v-if="(idx+1)< item.data.allContactsPersons.length">|</span>
            </span>
            <br>
            <span class="size-14 primary--text">
              #{{item.data.natureDic  === null || item.data.natureDic  === undefined  ? '' : item.data.natureDic.name}}客户
              #{{item.data.typeDic  === null || item.data.typeDic  === undefined  ? '' : item.data.typeDic.name}}
              #{{item.data.levelDic  === null || item.data.levelDic  === undefined  ? '' : item.data.levelDic.name}}
              #{{item.data.tradeDic  === null || item.data.tradeDic  === undefined  ? '' : item.data.tradeDic.name}}
            </span>
          </div>
        </v-card-title>

        <v-card-text>
           <v-row justify='start' class="my-1">
            <v-col cols="12" class="pl-0">
              <v-icon color="grey" size="21" class="mr-2">mdi-account-multiple-outline</v-icon>
               <span  v-for="(item, idx) in item.data.contactsPersonList" :key="idx">
                <v-chip class="mr-1" small outlined>
                  <span class="font-weight-black">{{item.name}}</span>
                </v-chip>
              </span>
            </v-col>
          </v-row>
          <v-row justify='start' class="my-1">
            <v-col cols="12" class="pl-0">
              <v-icon color="grey" size="21" class="mr-2">mdi-map-marker</v-icon>
              <span class="size-15">{{item.data.address}}</span>
            </v-col>
          </v-row>
          <v-row justify='start' class="my-1">
            <v-col cols="12" md='3' class="px-1">
              <v-card class="pa-6" height="165">
                <div class="line-height-5 font-family-Impact primary--text size-20 text-center">
                  ¥<count-to :endVal='item.data.contractInfos | fmSignPrice' :duration='2000'></count-to>
                </div>
               <div class="line-height-1 font-family-Impact font-weight-bold grey--text size-16 text-center">总合同额</div>
              </v-card>
            </v-col>
            <v-col cols="12" md='3' class="px-1">
              <v-card class="pa-6" height="165">
                <p class="font-family-Impact primary--text size-25 text-center">
                 <v-progress-circular
                    :size="80"
                    :width="8"
                    :value="item.data.contractInfos | fmPassRatio"
                    color="teal"
                  >
                    <strong class="size-16">{{item.data.contractInfos | fmPassRatio}}%</strong>
                  </v-progress-circular>
                </p>
                <div class="font-family-Impact font-weight-bold grey--text size-16 text-center">项目通过率</div>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text class="text--disabled" @click='item.show = false'>
        关闭
      </v-btn>
    </v-card-actions>
  </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import CountTo from 'vue-count-to'

  export default {
    name: 'CustomerCard',
    components: {
      CountTo
    },
    filters: {
      fmSignPrice (array) {
        let money = 0.0
        if (array) {
          array.forEach(item => {
            if (item.order.auditStatus === 1) {
              money += item.signPrice
            }
          });
        }
        return money
      },
      fmPassRatio(array) {
        let passNum = 0
        let unPassNum = 0
        if (array) {
          array.forEach(item => {
            if (item.stateId === 237) {
              passNum += 1
            }
            if (item.stateId === 120) {
              unPassNum += 1
            }
          });
        }
        return (unPassNum + passNum) === 0 ? 0 : Math.ceil(passNum / (unPassNum + passNum) * 100)
      },
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null
        })
      }
    },
    data() {
      return {
        loading: false,
        form: {
        }
      }
    },
    methods: {
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined
      }
    }
  }
</script>

<style lang="sass" scoped>
</style>
